module.exports = __webpack_public_path__ + "static/img/coupon_scan.1c9fdf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/coupon_scan.png
// module id = ejq7
// module chunks = 1